const closeCartToolPopup = (restoreFocus = true) => {
  const popup = document.querySelector('.popup-toolDown.show');
  if (!popup) return;

  const trigger = document.querySelector(`cart-item-tool [aria-controls="${popup.id}"]`);
  popup.classList.remove('show');
  document.querySelector('.previewCart')?.classList.remove('active-tool');

  if (trigger) {
    trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus) trigger.focus();
  }
};

class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      document.getElementById(button.dataset.popup)?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeCartToolPopup();
      });

      button.addEventListener('click',(event) => {
        const trigger = event.currentTarget;
        const id = trigger.dataset.popup;
        const popup = document.getElementById(id);
        if (!popup) return;

        trigger.setAttribute('aria-expanded', 'true');
        popup.classList.add('show');
        document.querySelector('.previewCart')?.classList.add('active-tool');

        requestAnimationFrame(() => {
          popup.querySelector('input, textarea, button')?.focus();
        });
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      closeCartToolPopup();
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      closeCartToolPopup();
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.button = this.querySelector('[data-update-coupon]');

    const storedDiscount = localStorage.getItem('storedDiscount');
    if (storedDiscount) this.input.value = storedDiscount;

    this.button.addEventListener('click', () => this.applyDiscount());
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.applyDiscount();
      }
    });
  }

  async applyDiscount() {
    const discount = this.input.value.trim();
    if (!discount || this.button.disabled) {
      if (!discount) this.input.focus();
      return;
    }

    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(window.routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({ discount })
      });

      if (!response.ok) throw new Error(window.cartStrings.error);

      const cart = await response.json();
      localStorage.setItem('storedDiscount', discount);
      closeCartToolPopup(false);

      if (window.sharedFunctions?.updateSidebarCart) {
        window.sharedFunctions.updateSidebarCart(cart);
      } else {
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
      }
    } catch (error) {
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
      this.input.focus();

      if (typeof showWarning === 'function') {
        showWarning(error.message || window.cartStrings.error);
      }
    }
  }
}

customElements.define('coupon-code', CouponCode);
